import React from 'react';
import classes from './Button.module.scss'
const Button = props => {
    let propsStyle;
    if(props.style) {        
        propsStyle = {
            backgroundColor : props.style.backgroundColor,
            color : props.style.color,
            fontSize: props.style.fontSize,
            marginTop: '10px'
        }
    }
    return (
        <button style={propsStyle ? propsStyle : {backgroundColor: props?.backgroundColor ?? props?.color ?? 'var(--a8-accent)', marginTop : '10px'}} onClick={props.onClick} className={props.outlined ? classes.OutlinedButton : classes.MaterialButton}>{props.btnText}</button>
    );
}

export default Button;
